<template lang="html">
  <div class="all">
    <b-modal v-model="showDeleteModal" ok-title="Yes" cancel-title="No" @hidden="resetSubIndexToRemove()"
      @ok="onSubsBlacklistRemove()">
      Note: Deleting the primary field's blacklist/whitelist<br>
      <b>will automatically remove all associated blacklist/whitelist entries related to that field</b>
    </b-modal>
    <h2>Edit Multi Offers</h2>
    <div v-if="showLoader" class="loader">
      Processing...
    </div>
    <div v-if="!showLoader">
      <form @submit.prevent="mulitApply">
        <div class="field-container">
          <label>Weight</label>
          <input type="number" min="0" max="99999" class='form-control pub-id-input' v-model="form.weight">
        </div>
        <div class="field-container">
          <label>Comments</label>
          <input class="pub-id-input form-control" v-model="form.sl_comments">
        </div>
        <div class=" field-container">
          <label>Click Cap(0=infinite)</label>
          <input class="pub-id-input form-control" v-model="form.cap">
        </div>
        <h4>CTA Offer</h4>
        <div class="field-container">
          <label>Frequency</label>
          <section v-for='i in [0, 24, 12, 6, 3, 1]' :key="'cta_frq-' + i">
            <label :for='"cta-frq-hours-" + i'>{{ i > 0 ? i + " Hours" : "None" }}</label>
            <input name="cta-frq" :id='"cta-frq-hours-" + i' type="radio" :value='i' v-model="form.frq">
          </section>
        </div>
        <div class="field-container">
          <label>IP Frequency</label>
          <section v-for='i in [0, 24, 12, 6, 3, 1]' :key="'cta_ip_frq-' + i">
            <label :for='"cta-ip-frq-hours-" + i'>{{ i > 0 ? i + " Hours" : "None" }}</label>
            <input name="cta-ip_frq" :id='"cta-ip-frq-hours-" + i' type="radio" :value='i' v-model="form.ip_frq">
          </section>
        </div>
        <div class="field-container">
          <label>Delivery Frequency</label>
          <input class="pub-id-input delivery_frq form-control" type="number" min="1" max="100"
            v-model.number="form.delivery_frq" @keyup="validateDeliveryPrecent">
          <strong v-if="valid_delivery_frq">{{ this.form.delivery_frq }}% </strong>

        </div>
        <div class="field-container" v-if="placementData.os == 'iOS'">
          <span>Os Version</span>
          <label>iOS</label>
          <select class="def select-234" name="" v-model='form.os_version_operator'>
            <option v-for='op in operators'>{{ op }}</option>
          </select>
          <select class="def select-234" v-model='form.os_version'>
            <option v-for='osv in iosVersionsFull' :value='osv.version'>{{ osv.version }} </option>
          </select>
        </div>
        <div class="field-container" v-if="placementData.os == 'Android'">
          <span>Os Version</span>
          <label>Android</label>
          <select class="def select-234" name="" v-model='form.os_version_operator'>
            <option v-for='op in operators'>{{ op }}</option>
          </select>
          <select class="def select-234" v-model='form.os_version'>
            <option v-for='osv in androidVersionsFull' :value='osv.version'>{{ osv.version }}</option>
          </select>
        </div>
        <div class="field-container">
          <label>Connection Type</label>
          <Select class='select' :options='connectionTypes' v-model="form.connection_type" />
        </div>
        <div class="field-container" v-if='this.geo != null && this.geo.length > 0 && form.connection_type == "3G"'>
          <label>Mobile Carrier</label>
          <cool-select v-if='isps' v-model="carrierSelected" :items="isps" />
          <ul class='selected-items'>
            <li @click='onCarrierDel(index)' v-for='(isps, index) in form.isps'>
              <i class="fa fa-times del-x" aria-hidden="true"></i>
              <span>
                {{ isps }}
              </span>
            </li>
          </ul>
          <div class="isp-checkbox">
            <input type="checkbox" v-model="form.isp_bl" name="BL">
            <label for="scales">Blacklist</label>
          </div>
        </div>
        <div v-if="offerType === 'vta'">
          <h4>VTA Offer</h4>
          <div class="field-container">
            <label>Frequency</label>
            <section v-for='i in [0, 24, 12, 6, 3, 1]' :key="'vta_frq-' + i">
              <label :for='"vta-frq-hours-" + i'>{{ i > 0 ? i + " Hours" : "None" }}</label>
              <input name="vta-frq" :id='"vta-frq-hours-" + i' type="radio" :value='i' v-model="form.click_offer.frq">
            </section>
          </div>
          <div class="field-container">
            <label>IP Frequency</label>
            <section v-for='i in [0, 24, 12, 6, 3, 1]' :key="'vta_ip_frq-' + i">
              <label :for='"vta-ip-frq-hours-" + i'>{{ i > 0 ? i + " Hours" : "None" }}</label>
              <input name="vta-ip_frq" :id='"vta-ip-frq-hours-" + i' type="radio" :value='i'
                v-model="form.click_offer.ip_frq">
            </section>
          </div>
          <div class="field-container">
            <label>CTR %</label>
            <input type="number" min="0" max="100" step="0.01" class="pub-id-input form-control" v-model="form.ctr">
          </div>
        </div>
        <div v-if="subsValidationError.length > 0" class="alert">
          <a class="close" @click="subsValidationError = []">&times;</a>
          <li v-for="msg in subsValidationError">{{ msg }}</li>
        </div>
        <div>
          <h4>Subs Blacklisting</h4>
          <div class="inline-container">
            <label>Sub:</label>
            <Select class="select" :options="unselectedSubs" v-model="new_sub_bl.sub" @change="changeSelectedSub" />
            <input id="new-sub-bl-wl" type="checkbox" v-model="new_sub_bl.whitelist">
            <label for="new-sub-bl-wl">Whitelist</label>
            <i class="fa fa-plus edit-btn" aria-hidden="true" @click='onSubsBlacklistAdd'></i>
          </div>
          <div>
            <span v-if="selectedSub === 'sub2'" style="color: red;">Case sensitive</span>
            <span v-if="selectedSub === 'sub4'" style="color: red;">Not case sensitive</span>
          </div>
          <div class="relative">
            <p class="absolute right top translate-y-100">
              <span>{{ new_sub_bl?.list?.length ? addCommaToNumber(new_sub_bl?.list?.length) : 0 }}</span> /
              <span>65,000</span>
            </p>
          </div>
          <LimitedTextarea class="max-textarea" rows="4" :max="3000000" v-model="new_sub_bl.list"></LimitedTextarea>
        </div>
        <br class="flat-breaks"><br>
        <div>
          <div v-for="(s, i) in form.blacklisting_subs">
            <div class="inline-container">
              <i class="fa fa-trash trash-btn" aria-hidden="true" @click='verifyBeforeRemove(i)'></i>
              <h5>{{ s.sub }}</h5>
              <i class="fa fa-plus edit-btn" aria-hidden="true" @click='addAnotherLimitedTextArea(s, i)'></i>
            </div>
            <div>
              <input v-model='s.whitelist' type="checkbox">
              <label>Whitelist</label>
            </div>
            <div>
              <span v-if="s.sub === 'sub2' || s.sub === 'sub3' || s.sub === 'sub7'" style="color: red;">Case
                sensitive</span>
              <span v-if="s.sub === 'sub4'" style="color: red;">Not case sensitive</span>
            </div>
            <div class="relative">
              <p class="absolute right top translate-y-100">
                <span>{{ s?.list?.length ? addCommaToNumber(s?.list?.length) : 0 }}</span> / <span>65,000</span>
              </p>
            </div>
            <LimitedTextarea class="max-textarea" rows="4" :max="3000000" v-model="s.list"></LimitedTextarea>
            <br class="flat-breaks"><br>
            <div v-for="(extra_sub_list, extra_sub_list_idx) in s.extra_sub_list">
              <i class="fa fa-trash trash-btn mb-3" aria-hidden="true"
                @click='removeOfferExtraBlWlRelatedSub(s, extra_sub_list)'></i>
              <div class="relative">
                <p class="absolute right top translate-y-100">
                  <span>{{ extra_sub_list.value?.length ? addCommaToNumber(extra_sub_list.value.length) : 0 }}</span> /
                  <span>65,000</span>
                </p>
                <LimitedTextarea class="max-textarea" rows="4" :max="3000000"
                  v-model="s.extra_sub_list[extra_sub_list_idx].value"></LimitedTextarea>
              </div>
              <br class="flat-breaks"><br>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-success btn-31214">Save and Apply to All Selected Offers</button>
      </form>
    </div>
  </div>
</template>

<script>
import {
  CoolSelect
} from "vue-cool-select";
export default {
  components: {
    CoolSelect
  },
  data() {
    return {
      showDeleteModal: false,
      subIndexToRemove: null,
      offerType: '',
      showLoader: true,
      form: {
        offers: [],
        weight: '',
        sl_comments: '',
        cap: '',
        frq: '',
        ip_frq: '',
        delivery_frq: '',
        ctr: '',
        connection_type: '',
        os_version: null,
        os_version_operator: null,
        blacklisting_subs: [],
        isps: [],
        isp_bl: false,
        click_offer: {
          frq: '',
          ip_frq: '',
        },
      },
      geo: [],
      connectionTypes: ['all', 'wifi', '3G'],
      operators: [
        ">=", "=", "<="
      ],
      iosVersionsFull: [],
      androidVersionsFull: [],
      placementData: {},
      all_subs: [{
        val: "sub1",
        label: "Sub1"
      },
      {
        val: "sub2",
        label: "Sub2"
      },
      {
        val: "sub3",
        label: "Sub3"
      },
      {
        val: "sub4",
        label: "Sub4"
      },
      {
        val: "sub6",
        label: "Sub6"
      },
      {
        val: "sub7",
        label: "Sub7"
      },
      {
        val: "sub8",
        label: "Sub8"
      }],
      new_sub_bl: {},
      selectedSub: '',
      subsValidationError: [],
      placement_id: this.$route.query.placement_id,
      sl_id: this.$route.query.camp_id,
      carrierSelected: null,
      all_isps: null,
      valid_delivery_frq: false,
    }
  },
  async created() {
    this.offerType = this.$route.query.type;
    await this.getVersions();
    await this.getPlacementsData();
    await this.fetchIsps();
    this.showLoader = false;
  },
  computed: {
    unselectedSubs() {
      if (!this.all_subs || !this.all_subs.length) {
        return
      }
      return this.all_subs.filter(v => !this.form.blacklisting_subs.find(v2 => v2.sub == v.val))
    },
    isps() {
      return this.all_isps
    },
  },
  watch: {
    carrierSelected(value) {
      if (value != null) {
        if (this.form.isps == null) {
          this.form.isps = []
        }
        this.form.isps.push(value)
      }
    },
    ['form.connection_type'](newValue) {
      if (newValue !== '3G') {
        this.form.isps = []
      }
    },
    ['form.cap'](newValue) {
      if (newValue !== null) {
        const result = newValue.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$set(this.form, 'cap', result);
      }
    },
  },
  methods: {
    async validateDeliveryPrecent() {
      const val = parseInt(this.form.delivery_frq);

      if (val > 0 && val <= 100) {
        this.valid_delivery_frq = true;
      } else {
        this.valid_delivery_frq = false;
        this.notifyError('Delivery frequency must be between 1 and 100');
      }
    },
    mulitApply: async function () {
      for (let k in this.form.blacklisting_subs) {
        if (this.form.blacklisting_subs[k].list.length > 65000) {
          this.notifyError(`Sub BL/WL Can't be more than 65000 characters`)
          return
        }
        for (let i in this.form.blacklisting_subs[k].extra_sub_list) {
          if (this.form.blacklisting_subs[k].extra_sub_list[i].value.length > 65000) {
            this.notifyError(`Offers extra sub BL/WL Can't be more than 65000 characters`)
            return
          }
        }
      }
      this.subsValidationError = []
      const subsMsgArray = await this.validateBlacklistingSubs()
      if (Object.keys(subsMsgArray).length > 0) {
        this.ThrowSubsAlerts(subsMsgArray)
        return
      }
      const payload = {
        offers: this.$route.query.offer_ids.split('-').map(v => parseInt(v)),
      };

      if (this.form.weight !== '' && this.form.weight !== null) payload.weight = parseInt(this.form.weight);
      if (this.form.sl_comments !== '') payload.sl_comments = this.form.sl_comments;
      if (this.form.cap !== '' && this.form.cap !== null) {
        payload.cap = parseInt(this.form.cap.toString().replace(/,/g, ''));
      }
      if (this.form.delivery_frq !== '') payload.delivery_frq = parseInt(this.form.delivery_frq);
      if (this.form.connection_type !== '' && this.form.connection_type !== null) {
        payload.connection_type = this.form.connection_type;
        if (this.form.connection_type === '3G') {
          payload.isps = this.form.isps;
          payload.isp_bl = this.form.isp_bl;
        } else {
          payload.isps = [];
        }
      }
      if (this.form.os_version !== null) payload.os_version = this.form.os_version_operator + this.form.os_version;
      if (this.form.frq !== '') payload.frq = this.form.frq;
      if (this.form.ip_frq !== '') payload.ip_frq = this.form.ip_frq;
      if (this.form.blacklisting_subs.length > 0) {
        payload.blacklisting_subs = this.form.blacklisting_subs.map(v => ({
          sub: v.sub,
          list: v.list,
          whitelist: v.whitelist,
        }))
        const extraSubs = this.form.blacklisting_subs.flatMap(v =>
          v.extra_sub_list || []).map(v2 => (
            {
              value: v2.value,
              sub_idx: v2.sub_idx,
              sub: v2.sub,
              sl_id: this.sl_id,
              placement_id: this.placement_id,
            }))
        if (extraSubs.length > 0) {
          payload.extra_sub_list = extraSubs
        }
      }
      if (this.offerType === 'vta') {
        payload.click_offer = {
          offers: this.$route.query.click_offer_ids.split('-').map(v => parseInt(v)),
        };
        if (this.form.click_offer.frq !== '' && this.form.click_offer.frq !== null) {
          payload.click_offer.frq = this.form.click_offer.frq;
        }

        if (this.form.click_offer.ip_frq !== '' && this.form.click_offer.ip_frq !== null) {
          payload.click_offer.ip_frq = this.form.click_offer.ip_frq;
        }
        if (this.form.ctr !== '') payload.ctr = parseFloat(this.form.ctr);
      }
      try {
        this.showLoader = true
        const r = await this.$http.post(this.resources.SmartLinksCampaigns.updateMultiOffers(this.$route.query.camp_id, this.$route.query.placement_id), payload);
        if (r.status === 200) {
          this.notifySuccess("Offers updated successfully.");
          setTimeout(() => {
            window.location.href = `/apps/smartlinks/campaigns/${this.$route.query.camp_id}/placements/${this.$route.query.placement_id}/`;
          }, 1500);
        }
      } catch (err) {
        const errMsg = err.body || "Error occured"
        this.notifyError(errMsg)
        this.showLoader = false
      }
    },
    async validateBlacklistingSubs() {
      let subsMsgObject = {};

      for (let k in this.form.blacklisting_subs) {
        const subEntry = this.form.blacklisting_subs[k];
        const invalidChars = subEntry.list.match(/[\r\n\t\f\v\s]/g) || [];
        let lastMatch = 0;
        let messages = [];

        for (const char of invalidChars) {
          lastMatch = subEntry.list.indexOf(char, lastMatch);
          messages.push({
            str: subEntry.list.substring(Math.max(0, lastMatch - 10), lastMatch + 10),
            char
          });
          lastMatch++;
        }

        for (let extra of (subEntry.extra_sub_list || [])) {
          const invalidExtraChars = extra.value.match(/[\r\n\t\f\v\s]/g) || [];
          for (const char of invalidExtraChars) {
            messages.push({
              str: extra.value.substring(0, 20),
              char
            });
          }
        }

        if (messages.length > 0) {
          subsMsgObject[subEntry.sub] = messages;
        }
      }

      return subsMsgObject;
    },
    ThrowSubsAlerts(subsMsgArray) {
      let msg = []
      for (const sub in subsMsgArray) {
        for (const { char, str } of subsMsgArray[sub]) {
          let charDesc = {
            ' ': 'space',
            '\n': 'line break',
            '\t': 'tab',
            '\r': 'carriage return',
            '\f': 'form feed',
            '\v': 'vertical tab'
          }[char] || `unknown character (${char.charCodeAt(0)})`;

          msg.push(`Invalid ${charDesc} in ${sub} near → "${str}"`);
        }
      }

      this.subsValidationError = msg;
    },
    getVersions: async function () {
      try {
        const r = await this.$http.get(this.resources.Management.getOsVersions("ios"))
        const ios = await r.json()
        this.iosVersionsFull = ios

        const i = await this.$http.get(this.resources.Management.getOsVersions("android"))
        const android = await i.json()
        this.androidVersionsFull = android
      } catch (err) {
        this.notifyError("can't fetch os versions")
      }
    },
    getPlacementsData: async function () {
      const r = await this.$http.get(this.resources.SmartLinksCampaigns.smartLinksCampaignData(this.$route.query.camp_id));
      var placements = await r.json();
      this.placementData = placements.find(v => v.id == this.$route.query.placement_id);
      if (this.placementData && this.placementData.geo) {
        this.geo = [this.placementData.geo]
      }
    },
    addCommaToNumber: function (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onSubsBlacklistAdd() {
      if (!this.new_sub_bl || !this.new_sub_bl.sub) {
        return;
      }
      this.selectedSub = '';
      let newsub = this.new_sub_bl;
      this.new_sub_bl = {};
      newsub.sub = newsub.sub.val;
      newsub.extra_sub_list = [];
      this.form.blacklisting_subs.unshift(newsub)
    },
    addAnotherLimitedTextArea(s, idx) {
      let { campId, placementId, offerId } = this.$route.params
      const current_form = JSON.parse(JSON.stringify(this.form));
      current_form.blacklisting_subs[idx] = {
        ...s,
        extra_sub_list: [...s.extra_sub_list, { value: '', sub_idx: s.extra_sub_list.length, sub: s.sub, sl_id: campId, placement_id: placementId, offer_id: offerId }]
      }
      this.form = current_form;
    },
    changeSelectedSub() {
      if (!this.new_sub_bl || !this.new_sub_bl.sub) {
        return
      } else {
        this.selectedSub = this.new_sub_bl.sub.val
      }
    },
    resetSubIndexToRemove() {
      this.subIndexToRemove = null
      this.showDeleteModal = false
    },
    verifyBeforeRemove(index) {
      this.subIndexToRemove = index
      this.showDeleteModal = true
    },
    onSubsBlacklistRemove(i) {
      this.form.blacklisting_subs.splice(this.subIndexToRemove, 1);
      this.showDeleteModal = false;
      this.subIndexToRemove = null;
    },
    removeOfferExtraBlWlRelatedSub(s, extra_sub_list) {
      const current_form = JSON.parse(JSON.stringify(this.form));
      current_form.blacklisting_subs.forEach((sub, idx) => {
        if (sub.sub === s.sub) {
          current_form.blacklisting_subs[idx].extra_sub_list = current_form.blacklisting_subs[idx].extra_sub_list.filter((sub) => sub.sub_idx !== extra_sub_list.sub_idx)
          current_form.blacklisting_subs[idx].extra_sub_list = current_form.blacklisting_subs[idx].extra_sub_list.map((sub, idx) => {
            sub.sub_idx = idx
            return sub
          })
        }

      })
      this.form = current_form;
    },
    fetchIsps: async function () {
      if (this.geo && this.geo.length > 0) {
        try {
          const r = await this.$http.get(this.resources.SmartLinksCampaigns.getISPs, {
            params: {
              countries: this.geo
            }
          })
          const isps = await r.json()
          this.all_isps = isps
        } catch (err) {
          this.notifyError("can't fetch isps")
        }
      }
    },
    onCarrierDel(index) {
      this.form.isps.splice(index, 1)
    },
  },
}
</script>
<style>
.alert {
  padding: 20px;
  margin-bottom: 15px;
  position: fixed;
  top: 5%;
  left: 25%;
  right: 0;
  z-index: 999999;
  width: 50%;
  box-shadow: 0 0 15px 5px #ccc;
  border-radius: 5px;
  background-color: lightcoral;
}

.max-textarea {
  width: 100%;
}

.inline-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.inline-container>* {
  margin-right: 9px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.right {
  right: 0;
}

.top {
  top: 0;
}

.translate-y-100 {
  transform: translateY(-100%);
}

.flat-breaks br {
  content: "";
}

.flat-breaks br:after {
  content: " ";
}
</style>